<template>
  <router-link class="score-return-link" to="/score">返回积分商城</router-link>
</template>

<script>
/**
 * 积分页面共用的商城返回入口。
 * @author tz
 * @date 2026-09-17
 */
export default {
  name: 'ScoreReturnLink'
}
</script>

<style scoped lang="less">
.score-return-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 24px;
  border-radius: 4px;
  background: #57aca7;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}
.score-return-link:hover {
  background: #499b96;
  color: #fff;
}
.score-return-link:active {
  background: #367d79;
}
.score-return-link:focus-visible {
  outline: 2px solid #367d79;
  outline-offset: 2px;
}
</style>
